import { useConfig } from "../../context/config-context";
import Input from "../Inputs/Input";

export const InputEmail = ({
  id,
  register,
  disabled,
  fieldName = "email",
  error,
}) => {
  const siteConfig = useConfig();

  return (
    <Input
      id={id}
      disabled={disabled}
      label={siteConfig.components.email.label}
      placeholder={siteConfig.components.email.placeholder}
      type="email"
      {...register(fieldName, {
        required: siteConfig.components.email.required,
        pattern: {
          value: siteConfig.pattern.email,
          message: siteConfig.components.email.invalid,
        },
      })}
      error={error}
    />
  );
};

export default InputEmail;
